<div _ngcontent-c0="" class="app-content ui basic segment container">
  <div _ngcontent-c3="" class="ui basic segment wrapper">

    <div class="full-width ui basic segment">

      <!-- <app-breadcrumb></app-breadcrumb> -->

      <h1 class="ui block header">
        Privacy policy
      </h1>

      <div class="ui basic segment">
        <h4>1.Introduction</h4>
        <div style="padding-left: 30px;"><strong>1.1</strong> We are committed to
          safeguarding the privacy of our portal users; in this policy we</div>
        <div style="padding-left: 60px;">explain how we will treat your personal information.</div>
        <div style="padding-left: 30px;"><strong>1.2</strong> By using our portal and
          agreeing to this policy, you consent to our use of cookies in</div>
        <div style="padding-left: 60px;">accordance with the terms of this policy.</div>
        <div style="padding-left: 60px;">&nbsp;</div>
        <div><strong>2.Collecting personal information</strong></div>
        <div>&nbsp;</div>
        <div style="padding-left: 30px;"><strong>2.1</strong> We may collect, store
          and use the following kinds of personal information</div>
        <div style="padding-left: 60px;"><strong>(a)</strong> [information about your
          computer and about your visits to and use of this portal (including [your IP address, geographical location,
          browser type and version, operating system, referral source, length of visit, page views and portal navigation
          paths]);]</div>
        <div style="padding-left: 60px;"><strong>(b)</strong> [information that you
          provide to us when registering with our portal (including [your email address]);]</div>
        <div style="padding-left: 60px;"><strong>(c)</strong> [information that you
          provide when completing your profile on our portal (including [your name, gender, date of birth]</div>
        <div style="padding-left: 60px;"><strong>(e)</strong> [information that you
          provide to us when using the services on our portal, or that is generated in the course of the use of those
          services (including [the timing, frequency and pattern of service use];]</div>
        <div style="padding-left: 90px;"><strong>(i)</strong> [any other personal
          information that you choose to send to us; and]</div>
        <div style="padding-left: 30px;"><strong>2.2</strong> Before you disclose to
          us the personal information of another person, you must</div>
        <div style="padding-left: 60px;">obtain that person's consent to both the disclosure and the
          processing of that personal information in accordance with this policy.</div>
        <div style="padding-left: 60px;">&nbsp;</div>
        <div><strong>3.Using your personal information</strong></div>
        <div>&nbsp;</div>
        <div style="padding-left: 30px;"><strong>3.1</strong> Personal information
          submitted to us through our portal will be used for the purposes</div>
        <div style="padding-left: 60px;">specified in this policy or on the relevant pages of the
          portal.</div>
        <div style="padding-left: 30px;"><strong>3.2</strong> We may use your personal
          information to:</div>
        <div style="padding-left: 60px;"><strong>(a)</strong> [discharge our
          regulatory responsibility;]</div>
        <div style="padding-left: 60px;"><strong>(b)</strong> [enable your use of the
          services available on our portal;]</div>
        <div style="padding-left: 60px;"><strong>(c)</strong> [send statements,
          invoices and payment reminders to you, and collect payments from you;]</div>
        <div style="padding-left: 60px;"><strong>(d)</strong> [send you email
          notifications that you have specifically requested;]</div>
        <div style="padding-left: 60px;"><strong>(e)</strong> [deal with enquiries and
          complaints made by or about you relating to our portal;]</div>
        <div style="padding-left: 60px;"><strong>(f)</strong> [keep our portal secure
          and prevent fraud;]</div>
        <div style="padding-left: 30px;"><strong>3.3</strong> [We will not, without
          your express consent, supply your personal information to any</div>
        <div style="padding-left: 60px;">third party for the purpose of their or any other third
          party's direct marketing.]</div>
        <div style="padding-left: 30px;"><strong>3.4</strong> [All our portal
          financial transactions are handled through our payment services</div>
        <div style="padding-left: 60px;">provider, [PSP name]. You can review the provider's privacy
          policy at [URL]. We will share information with our payment services provider only to the extent necessary for
          the purposes of processing payments you make via our portal, refunding such payments and dealing with
          complaints and queries relating to such payments and refunds.]</div>
        <div style="padding-left: 60px;">&nbsp;</div>
        <div><strong>4.Disclosing personal information</strong></div>
        <div>&nbsp;</div>
        <div style="padding-left: 30px;"><strong>4.1</strong> We may disclose your
          personal information to [any of our employees, officers,</div>
        <div style="padding-left: 60px;">insurers, professional advisers, agents, suppliers or
          subcontractors] insofar as reasonably necessary for the purposes set out in this policy.</div>
        <div style="padding-left: 30px;"><strong>4.2</strong> [We may disclose your
          personal information to any authorised agency for</div>
        <div style="padding-left: 60px;">investigation purposes.]</div>
        <div style="padding-left: 30px;"><strong>4.3</strong> We may disclose your
          personal information:</div>
        <div style="padding-left: 60px;"><strong>(a)</strong> to the extent that we
          are required to do so by law;</div>
        <div style="padding-left: 60px;"><strong>(b)</strong> in connection with any
          ongoing or prospective legal proceedings;</div>
        <div style="padding-left: 60px;"><strong>(c)</strong> in order to establish,
          exercise or defend our legal rights (including providing information to others for the purposes of fraud
          prevention and reducing credit risk);</div>
        <div style="padding-left: 60px;"><strong>(d)</strong> [to any person who we
          reasonably believe may apply to a court or other competent authority for disclosure of that personal
          information where, in our reasonable opinion, such court or authority would be reasonably likely to order
          disclosure of that personal information.]</div>
        <div style="padding-left: 30px;"><strong>4.4</strong> [All our portal
          financial transactions are handled through our payment services</div>
        <div style="padding-left: 60px;">provider, [PSP name]. You can review the provider's privacy
          policy at [URL]. We will share information with our payment services provider only to the extent necessary for
          the purposes of processing payments you make via our portal, refunding such payments and dealing with
          complaints and queries relating to such payments and refunds.]</div>
        <div style="padding-left: 30px;"><strong>4.5</strong> Except as provided in
          this policy, we will not provide your personal information to</div>
        <div style="padding-left: 60px;">third parties.</div>
        <div>&nbsp;</div>
      </div>


    </div>
  </div>
</div>
